export default __webpack_public_path__ + "images/Fetal_Abdominal_Standard_Plane.1c84b38dd02997c6248ba8b8bc403c64.png";